<script lang="ts">
  import type { HTMLImgAttributes } from 'svelte/elements';

  type $$Props = HTMLImgAttributes;
  // TODO: add placeholder="blur" prop

  export let alt: $$Props['alt'] = '';
  export let loading: $$Props['loading'] = 'lazy'; // default loading to lazy
</script>

<!-- TODO: add preload prop -->
<!-- <svelte:head>
  {#if preload}
    <link
      rel="preload"
      as="image"
      href={$$props.src}
      imagesrcset={$$props.srcset}
      imagesizes={$$props.sizes}
    />
  {/if}
</svelte:head> -->

<img {alt} {loading} {...$$restProps} />
